const currencySymbols = {
  AUS: 'AUD $',
  US: 'USD $',
  ASIA_US: 'USD $',
  SG: 'SGD $',
  UK: 'GBP £',
  EU: 'EUR €',
  HK: 'HKD $'
};





const getCostForAddon = (costForAddon) => {
  const { cost, billingEntityCode } = costForAddon || {};
  if (!cost || !billingEntityCode) {
    return {};
  }

  return {
    numberValue: Number(cost),
    withCurrency: `${currencySymbols[billingEntityCode]}${cost}`,
    billingEntityCode
  };
};

export default getCostForAddon;